<template>
  <div class="contentt">
    <div class="show-div">
      <div class="show-item">
        <p>实习信息化管理平台</p>
        <img src="../assets/image/icon_01.png" />
        <p>全面智能的实习信息化全流程解决方案，已累计服务近千所院校，采用国内云计算和大数据技术，以专业的信息化平台实现院校实习过程实时跟踪和在线协同智能化管理。</p>
      </div>
      <div class="show-item">
        <p>实践教学综合管理方案</p>
        <img src="../assets/image/icon_02.png" />
        <p>我们提供院校实践教学管理综合解决方案，集校内实践、校外实习、校企合作、毕业设计（论文）管理等多方实现信息化、流程化、智能化、数据化教学管理。</p>
      </div>
      <div class="show-item">
        <p>实验实训室智能管理平台</p>
        <img src="../assets/image/icon_03.png" />
        <p>针对院校实验实训室管理，提供实验实训室基本信息管理、实验实训安全管理、实验实训检查系统、实验实训设备及耗材管理、实训课程计划管理等全方位实验实训管理解决方案，有效提升院校实验实训管理效率，尤其是安全管理！</p>
      </div>
    </div>
    <div class="company-info">
      <div class="item-l">
        <p>万博云信（北京）教育科技有限公司</p>
        <img src="../assets/image/line_1.png" />
        <p class="p-content">万博云信（北京)教育科技有限公司2015年成立于北京，
          <!-- <span style="font-weight:bold">中关村高新技术企业</span>， -->
          公司由国内职业教育专家和互联网资深人士组建，先后获得多轮机构投资，是国内实习实训信息化管理服务商，在全国各地设有10多个办事处。公司始终专注于提供院校学生实习、就业跟踪、校企合作等整体解决方案，产品<span style="font-weight:bold">“习讯云”</span>利用云计算、移动互联网和大数据技术，实现院校实习管理、就业跟踪、校企合作、实践教学管理、实验实训管理业务流程化、智能化、精细化和数据化，产品先后在全国高职高专校长联席会议、全国中职校长联席会议、全国技工院校校长论坛等全国性会议进行推荐宣传，<span style="font-weight:bold">目前公司已合作院校数百家，是全国具有省级实习管理平台和市级实习管理平台建设运营案例的服务商！</span></p>
        <div class="div-but">
          <el-button type="primary" @click="handleClickTo('/AboutUs')" plain>公司介绍</el-button>
          <el-button type="primary" @click="handleClickTo('/ContactUs')"  plain>联系我们</el-button>
        </div>
      </div>
      <div class="item-r">
        <!-- <el-carousel :interval="5000">
          <el-carousel-item v-for="item in imgs" :key="item">
            <el-image style="height:100%" :src="item" fit="cover"></el-image>
          </el-carousel-item>
        </el-carousel> -->
        <img style="width:100%" src="../assets/image/educa.jpg" />
      </div>
    </div>

    <div class="full_content">
      <div>
        <h1>30+</h1>
        <p>覆盖省份</p>
      </div>
      <div>
        <h1>800+</h1>
        <p>服务院校</p>
      </div>
      <div>
        <h1>200万+</h1>
        <p>服务师生</p>
      </div>
    </div>
    <School @openDrawf="openDrawf" />
    <div class="new-content" v-if="1!=1">
      <div class="title">
        <img src="../assets/image/x_2_left.png" />
        <span>较新动态</span>
        <img src="../assets/image/x_2_right.png" />
      </div>
      <div class="content">
        <ul>
          <li>
            <div class="date-title">
              <p>08</p>
              <p>2020-09</p>
            </div>
            <div class="txt">
              <p>注册会计师成立行业党委</p>
              <p>因长达半月出差，李海东没赶上陪儿子参加中考，颇感内疚。然而作为—名党员和业务骨干，在工作需要时，她抛家不顾。如今，在兴业所党员中，遇到棘手案件主动请缨已蔚然成风。</p>
            </div>
          </li>
          <li>
            <div class="date-title">
              <p>08</p>
              <p>2020-09</p>
            </div>
            <div class="txt">
              <p>注册会计师成立行业党委</p>
              <p>因长达半月出差，李海东没赶上陪儿子参加中考，颇感内疚。然而作为—名党员和业务骨干，在工作需要时，她抛家不顾。如今，在兴业所党员中，遇到棘手案件主动请缨已蔚然成风。</p>
            </div>
          </li>
          <li>
            <div class="date-title">
              <p>08</p>
              <p>2020-09</p>
            </div>
            <div class="txt">
              <p>注册会计师成立行业党委</p>
              <p>因长达半月出差，李海东没赶上陪儿子参加中考，颇感内疚。然而作为—名党员和业务骨干，在工作需要时，她抛家不顾。如今，在兴业所党员中，遇到棘手案件主动请缨已蔚然成风。</p>
            </div>
          </li>
          <li>
            <div class="date-title">
              <p>08</p>
              <p>2020-09</p>
            </div>
            <div class="txt">
              <p>注册会计师成立行业党委</p>
              <p>因长达半月出差，李海东没赶上陪儿子参加中考，颇感内疚。然而作为—名党员和业务骨干，在工作需要时，她抛家不顾。如今，在兴业所党员中，遇到棘手案件主动请缨已蔚然成风。</p>
            </div>
          </li>
          <li>
            <div class="date-title">
              <p>08</p>
              <p>2020-09</p>
            </div>
            <div class="txt">
              <p>注册会计师成立行业党委</p>
              <p>因长达半月出差，李海东没赶上陪儿子参加中考，颇感内疚。然而作为—名党员和业务骨干，在工作需要时，她抛家不顾。如今，在兴业所党员中，遇到棘手案件主动请缨已蔚然成风。</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="button">
        <el-button type="primary">更多信息</el-button>
      </div>
    </div>
    <!-- <div class="h-box">
      <div class="h-t"></div>
      <div class="h-l">
        <h1 style="margin-top:24px;color:#ece6e9;">Logo And LogOut</h1>
      </div>
      <div class="h-r">
      </div>
    </div> -->
  </div>
</template>

<script>
import School from './schools.vue';

export default {
  name: 'Contentt',
  data() {
    return {
      proList: [],
      imgs: ['http://tpl-c80a057.pic41.websiteonline.cn/upload/home_ab_01.jpg', 'http://tpl-c80a057.pic41.websiteonline.cn/upload/home_ab_02.jpg'],
    };
  },
  components: {
    School,
  },
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    handleClickTo(url){
      this.$router.push({path:url})
    },
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    openDrawf() {
      this.$emit('opend');
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
.contentt {
  // background: #b75d5d;
  .new-content {
    padding: 100px 0 0;
    color: #444;
    .button {
      padding: 56px 32px;
    }
    .title {
      margin-bottom: 72px;
      span {
        margin: 0 16px;
        font-size: 26px;
      }
      img {
        vertical-align: text-top;
      }
    }
    .content {
      padding: 0 80px;
      ul {
        li {
          padding: 24px 32px;
          display: flex;
          border-bottom: 1px dotted #dbd4cd;
          margin: 10px 0;
          .date-title {
            width: 64px;
            height: 64px;
            text-align: center;
            margin-right: 16px;
            color: #fff;
            background: #9d2c2c;
            line-height: 20px;
            p:first-child {
              font-weight: bold;
              font-size: 24px;
              margin-top: 14px;
            }
            p:last-child {
              font-size: 12px;
            }
          }
          .txt {
            flex: 1;
            p:first-child {
              font-size: 20px;
              color: #434343;
              cursor: pointer;
            }
            p:first-child:hover {
              color: #9d2c2c;
            }
            p:last-child {
              padding-top: 4px;
              font-size: 14px;
              color: #838383;
            }
          }
        }
      }
    }
  }
  .full_content {
    margin-top: 54px;
    height: 240px;
    background-color: transparent;
    background-image: url('../assets/image/xxmap.jpg');
    background-position: center center;
    background-repeat: repeat-x;
    display: flex;
    justify-content: center;
    div {
      width: 400px;
      height: inherit;
      text-align: center;
      h1 {
        margin-top: 72px;
        color: #487fb7;
        font-size: 44px;
      }
      p {
        margin-top: 24px;
        color: #444;
        font-size: 18px;
      }
    }
  }
  .company-info {
    display: flex;
    height: 466px;
    padding: 64px 0 72px;
    text-align: left;
    width: 1200px;
    margin: 0 auto;
    .item-l {
      width: 40%;
      padding-right: 32px;
      p:first-child {
        font-size: 22px;
        padding: 8px 0 2px;
      }
      .p-content {
        font-size: 14px;
        line-height: 24px;
        color: #666;
        text-indent:12px;
      }
      .div-but {
        padding-top: 54px;
        color: #fefefe;
      }
    }
    .item-r {
      width: 60%;
      height: inherit;
      /deep/.el-carousel__container {
        height: 400px;
      }
    }
  }
  .show-div {
    display: flex;
    justify-content: space-between;
    margin: -64px auto 0;
    z-index: 666;
    position: relative;
    margin-bottom: 32px;
    width: 1200px;
    .show-item {
      width: 292px;
      // height: 292px;
      background: #ffffff;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 35px 0px;
      padding: 40px;
      p:first-child {
        font-size: 22px;
        padding: 8px;
      }
      img {
        padding: 40px 0 32px;
      }
      p:last-child {
        color: #666666;
        line-height: 28px;
        text-align: left;
        text-indent: 24px;
      }
    }
    .show-item:hover {
      background: #c5ddf1;
    }
  }
  /deep/.el-button + .el-button {
    margin-left: 18px;
  }
  /deep/.el-button--primary {
    padding: 16px 48px;
    color: #4b6b8c;
    font-weight: bold;
    background: #fff;
    border-color: #4b6b8c;
    border-width: 2px;
    border-radius: 0;
  }
  /deep/.el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover{
    background: #4b6b8c;
    border-color: #4b6b8c;
    color:#fff;
  }
}
</style>
